import collapse from "@alpinejs/collapse";
import intersect from "@alpinejs/intersect";
import Alpine from "alpinejs";
import Auction from "./components/auction";
import Carousel from "./components/carousel";
import Footer from "./components/footer";
import GoalHighlight from "./components/goal-highlight";
import Header from "./components/header";
import InteractivePlayerCard from "./components/interactive-player-card";
import Jumbotron from "./components/jumbotron";
import Karaoke from "./components/karaoke";
import MediaModal from "./components/media-modal";
import MultiSelectFilter from "./components/multi-select-filter";
import NavigationTabs from "./components/navigation-tabs";
import ProductsCarousel from "./components/products-carousel";
import Select from "./components/select";
import Share from "./components/share";
import SortableTable from "./components/sortable-table";
import TimelineProgress from "./components/timeline-progress";
import {
  initPwa,
  PwaOnboarding,
  PwaSettings,
  registerPwaInstallBannerStore,
} from "./pwa";
import { registerPwaPrefsStore } from "./pwa-prefs";
import cmsStore from "./stores/cms";

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.store("layout", {
  mobileMenuOpen: false,
});

// PWA stores before Alpine.start() so templates can bind to $store.*
registerPwaPrefsStore(Alpine);
registerPwaInstallBannerStore(Alpine);

Alpine.store("cms", cmsStore);

Alpine.data("header", Header);
Alpine.data("footer", Footer);
Alpine.data("navigationTabs", NavigationTabs);
Alpine.data("select", Select);
Alpine.data("multiSelectFilter", MultiSelectFilter);
Alpine.data("interactivePlayerCard", InteractivePlayerCard);
Alpine.data("carousel", Carousel);
Alpine.data("karaoke", Karaoke);
Alpine.data("mediaModal", MediaModal);
Alpine.data("pwaOnboarding", PwaOnboarding);
Alpine.data("pwaSettings", PwaSettings);
Alpine.data("sortableTable", SortableTable);
Alpine.data("jumbotron", Jumbotron);
Alpine.data("productsCarousel", ProductsCarousel);
Alpine.data("share", Share);
Alpine.data("auction", Auction);
Alpine.data("goalHighlight", GoalHighlight);
Alpine.data("timelineProgress", TimelineProgress);

Alpine.start();

// After start: SW register + banner bootstrap (listeners / show)
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPwa);
} else {
  initPwa();
}
